import React from 'react'

export default function UnsplashIcon() {
  return (
    <svg role="img" viewBox="0 0 24 24" width="1em" height="1em">
      <title />
      <path d="M7.5 6.75V0h9v6.75h-9zm9 3.75H24V24H0V10.5h7.5v6.75h9V10.5z" />
    </svg>
  )
}
